import styled from 'styled-components';

export const DetailsWrapper = styled.div`
  background-color: ${props => props.theme.colors.mediumDarkGray};
  padding: ${props => (props.isOverlay ? '10px 20px' : '5px 10px')};
  font-family: ${props => props.theme.fontSets.narrowRegular};
  font-size: ${props => (props.isOverlay ? '15' : '13')}px;
  position: absolute;
  width: 100%;
  z-index: 9999;
  box-shadow: ${props => (props.isOverlay ? '0px 2px 4px 1px rgba(0,0,0,0.4)' : '0px 4px 4px 2px rgba(127,127,127,0.5)')};
  cursor: default;
`;

export const DetailsLink = styled.a`
  display: block;
  &:hover {
    color: ${props => props.theme.colors.orange}
  }
  &.no-event{
    pointer-events: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/PlayOffChart/MatchDetails/styles.js